import { gql } from "generated-graphql";

export const SITE_MANAGER_ACCESS_FOR_STAFF_QUERY = gql(`
  query SiteManagerAccessForStaff($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    siteManagerAccessForStaff(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        facilityId
        facilityName
        epaId
        city
        state
        tenantId
        tenantName
        siteManagerAccess
        reportedWasteGeneratorStatus
        calculatedWasteGeneratorStatus
        accessLastCheckedAt
      }
      count
    }
  }
`);

export const QUEUE_E_MANIFEST_SITE_ACCESS_JOB = gql(`
  mutation QueueEManifestSiteAccessJobFromSiteAccessTab {
    queueEManifestSiteAccessJob {
      id
      status
      task
    }
  }
`);
